export const sounds = [
    {
        id: 1,
        category: 'birds',
        name: 'birds',
        url: '/sounds/birds/birds_1.mp3'
    },
    {
        id: 2,
        category: 'birds',
        name: 'birds',
        url: '/sounds/birds/birds_2.mp3'
    },
    {
        id: 3,
        name: 'birds',
        url: '/sounds/birds/birds_3.mp3'
    },
    {
        id: 4,
        name: 'cafe',
        url: '/sounds/cafe/cafe_ambience_1.mp3'
    },
    {
        id: 5,
        name: 'cafe',
        url: '/sounds/cafe/cafe_ambience_2.mp3'
    },
    {
        id: 6,
        name: 'cafe',
        url: '/sounds/cafe/coffee_shop.mp3'
    },
    {
        id: 7,
        name: 'fire',
        url: '/sounds/fire/fire_1.mp3'
    },
    {
        id: 8,
        name: 'fire',
        url: '/sounds/fire/fire_2.mp3'
    },
    {
        id: 9,
        name: 'fire',
        url: '/sounds/fire/fire_3.mp3'
    },
    {
        id: 10,
        name: 'fire',
        url: '/sounds/fire/fire_4.mp3'
    },
    {
        id: 11,
        name: 'fire',
        url: '/sounds/fire/fire_5.mp3'
    },
    {
        id: 12,
        name: 'forest',
        url: '/sounds/forest/forest_1.mp3'
    },
    {
        id: 13,
        name: 'forest',
        url: '/sounds/forestforest_2.mp3'
    },
    {
        id: 14,
        name: 'noises',
        url: '/sounds/noises/pages.mp3'
    },
    {
        id: 15,
        name: 'ocean',
        url: '/sounds/ocean/ocean_1.mp3'
    },
    {
        id: 16,
        name: 'ocean',
        url: '/sounds/ocean/ocean_2.mp3'
    },
    {
        id: 17,
        name: 'rain',
        url: '/sounds/rain/rain_1.mp3'
    },
    {
        id: 18,
        name: 'rain',
        url: '/sounds/rain/rain_2.mp3'
    },
    {
        id: 19,
        name: 'rain',
        url: '/sounds/rain/rain_3.mp3'
    },
    {
        id: 20,
        name: 'river',
        url: '/sounds/river/river_1.mp3'
    },
    {
        id: 21,
        name: 'river',
        url: '/sounds/river/river_2.mp3'
    },
    {
        id: 22,
        name: 'river',
        url: '/sounds/river/river_3.mp3'
    },
    {
        id: 23,
        name: 'storm',
        url: '/sounds/storm/storm_1.mp3'
    },
    {
        id: 24,
        name: 'storm',
        url: '/sounds/storm/storm_2.mp3'
    },
    {
        id: 25,
        name: 'storm',
        url: '/sounds/storm/storm_3.mp3'
    },
];